const creditHealthUrl = "v1/credit/accounts/credit-health";
export {
  creditHealthUrl
};
//# sourceMappingURL=endpoints.js.map
